import React from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import useOrganisation from '../hooks/useOrganisation';
import propertyService from '../services/propertyService';
import PropertyList from '../components/property/PropertyList';
import PropertyForm from '../components/property/PropertyForm';
import PropertyDetail from '../components/property/PropertyDetail';
import FormField from '../components/common/FormField';
import Alert from '../components/common/Alert';
import LoadingSpinner from '../components/common/LoadingSpinner';
import './ApplicantPages.css';

const PropertyIndex = ({ organisation, organisations, onSelect }) => {
  const [properties, setProperties] = React.useState(null);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    setProperties(null);
    propertyService
      .list(organisation.id)
      .then((data) => setProperties(Array.isArray(data) ? data : data?.data || []))
      .catch((err) => setError(err.response?.data?.message || 'Your properties could not be loaded.'));
  }, [organisation.id]);

  return (
    <div className="ap-page">
      <div className="ap-title-row" style={{ justifyContent: 'space-between' }}>
        <h1>Properties</h1>
        {properties && properties.length > 0 && (
          <Link to="/properties/new" className="btn-primary ap-button">Add a property</Link>
        )}
      </div>

      {organisations.length > 1 && (
        <FormField
          label="Organisation"
          name="organisation"
          type="select"
          options={organisations.map((o) => ({ value: String(o.id), label: o.name }))}
          value={String(organisation.id)}
          onChange={(e) => onSelect(e.target.value)}
        />
      )}

      {error && <Alert type="error" message={error} />}
      {!properties && !error ? <LoadingSpinner /> : properties && <PropertyList properties={properties} />}
    </div>
  );
};

const PropertiesPage = () => {
  const { organisations, organisation, select, loading, error } = useOrganisation();

  if (loading) return <LoadingSpinner />;
  if (!organisation) {
    return (
      <div className="ap-page">
        {error && <Alert type="error" message={error} />}
        <div className="ap-card">
          <h2>Set up your organisation first</h2>
          <p>Properties belong to an organisation. It takes a minute to create one.</p>
          <Link to="/get-started" className="btn-primary ap-button">Get started</Link>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<PropertyIndex organisation={organisation} organisations={organisations} onSelect={select} />} />
      <Route path="/new" element={<PropertyForm organisation={organisation} />} />
      <Route path="/:id/edit" element={<PropertyForm organisation={organisation} />} />
      <Route path="/:id" element={<PropertyDetail />} />
    </Routes>
  );
};

export default PropertiesPage;
